"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestExistingPoliciesForMotor = exports.requestExistingPoliciesForVin = exports.requestExistingPoliciesForLicense = exports.requestExistingPoliciesForCarInfo = exports.resetMotorPolicy = exports.resetVinPolicy = exports.resetLicensePolicy = exports.overwriteCarPoliciesState = void 0;
var date_fns_1 = require("date-fns");
var network_1 = require("../../../network");
var carPolicies_1 = require("../../../functions/carPolicies");
var dateFormats_1 = require("../../../functions/helpers/dateFormats");
var dateFormat_1 = require("../../../constants/dateFormat");
var slice_1 = require("../slice");
var daysAheadSearchPolicy = 60;
/**
 * The store defines that it can have either a policy or "undefined", but since the server
 * is responding "null" when nothing is found and, since for typescript these 2 data types
 * do not overlap, we need to manually convert non existing values to undefined to prevent any
 * possible type collision crash.
 *
 * @param response - The response returned by the server
 */
function dataOrUndefined(response) {
    return response.data || undefined;
}
function validPolicy(policy) {
    return !carPolicies_1.isActive(policy) || typeof policy === 'undefined';
}
exports.overwriteCarPoliciesState = function (carPolicyState) { return function (dispatch) {
    dispatch(slice_1.overwriteCarPolicies(carPolicyState));
}; };
exports.resetLicensePolicy = function () { return function (dispatch, getState) {
    dispatch(slice_1.updatePoliciesForLicenseRequestStatus('initial'));
    if (typeof getState().carPolicies.carPolicyForVin === 'undefined') {
        dispatch(slice_1.updateMostRecentCarPolicy(undefined));
    }
    dispatch(slice_1.updateCarPolicyForLicense(undefined));
}; };
exports.resetVinPolicy = function () { return function (dispatch) {
    dispatch(slice_1.updatePoliciesForVinRequestStatus('initial'));
    dispatch(slice_1.updateCarPolicyForVin(undefined));
}; };
exports.resetMotorPolicy = function () { return function (dispatch) {
    dispatch(slice_1.updatePoliciesForMotorRequestStatus('initial'));
    dispatch(slice_1.updateCarPolicyForMotor(undefined));
}; };
// Extracted out logic to adhere to Sonar cloud's cognitive complexity requirement
// note that this is a pure function and not a redux thunk action
var localValidateMotor = function (dispatch, client, serialMotor) { return __awaiter(void 0, void 0, void 0, function () {
    var dateAhead, dateAheadString, currentDateString, motorResult, motorPolicy;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(serialMotor !== '')) return [3 /*break*/, 2];
                dateAhead = dateFormats_1.addDayToDate(new Date(), daysAheadSearchPolicy);
                dateAheadString = date_fns_1.format(dateAhead, dateFormat_1.dateFormatToServer);
                currentDateString = date_fns_1.format(new Date(), dateFormat_1.dateFormatToServer);
                dispatch(slice_1.updatePoliciesForMotorRequestStatus('requesting'));
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?motor=" + serialMotor + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 1:
                motorResult = _a.sent();
                motorPolicy = dataOrUndefined(motorResult);
                if (validPolicy(motorPolicy)) {
                    dispatch(slice_1.updateCarPolicyForMotor(motorPolicy));
                    dispatch(slice_1.updatePoliciesForMotorRequestStatus('success'));
                }
                else {
                    dispatch(slice_1.updatePoliciesForMotorRequestStatus('failure'));
                }
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
exports.requestExistingPoliciesForCarInfo = function (licensePlate, vin, motor, client) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var dateAhead, dateAheadString, currentDateString, result, policy, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(slice_1.updateValidateAllCarInfoRequestStatus('requesting'));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dateAhead = dateFormats_1.addDayToDate(new Date(), daysAheadSearchPolicy);
                dateAheadString = date_fns_1.format(dateAhead, dateFormat_1.dateFormatToServer);
                currentDateString = date_fns_1.format(new Date(), dateFormat_1.dateFormatToServer);
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?licensePlate=" + licensePlate + "&vin=" + vin + "&motor=" + motor + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 2:
                result = _a.sent();
                policy = dataOrUndefined(result);
                dispatch(slice_1.updateMostRecentCarPolicy(policy));
                return [2 /*return*/, dispatch(slice_1.updateValidateAllCarInfoRequestStatus('success'))];
            case 3:
                e_1 = _a.sent();
                return [2 /*return*/, dispatch(slice_1.updateValidateAllCarInfoRequestStatus('failure'))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports.requestExistingPoliciesForLicense = function (licensePlate, client, isNewCar, disableHasActivePolicyValidation) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var dateAhead, dateAheadString, currentDateString, result, policy, vinResult, vinPolicy, motorResult, motorPolicy, vinResult, vinPolicy, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(slice_1.updatePoliciesForLicenseRequestStatus('requesting'));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 9, , 10]);
                dateAhead = dateFormats_1.addDayToDate(new Date(), daysAheadSearchPolicy);
                dateAheadString = date_fns_1.format(dateAhead, dateFormat_1.dateFormatToServer);
                currentDateString = date_fns_1.format(new Date(), dateFormat_1.dateFormatToServer);
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?licensePlate=" + licensePlate + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 2:
                result = _a.sent();
                policy = dataOrUndefined(result);
                dispatch(slice_1.updateMostRecentCarPolicy(policy));
                dispatch(slice_1.updateCarPolicyForLicense(policy));
                if (!(typeof policy !== 'undefined' &&
                    !isNewCar &&
                    carPolicies_1.isActive(policy) &&
                    policy.serialBody !== '' &&
                    disableHasActivePolicyValidation)) return [3 /*break*/, 5];
                // fetch and validate linked VIN
                dispatch(slice_1.updatePoliciesForVinRequestStatus('requesting'));
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?vin=" + policy.serialBody + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 3:
                vinResult = _a.sent();
                vinPolicy = dataOrUndefined(vinResult);
                dispatch(slice_1.updateCarPolicyForVin(vinPolicy));
                dispatch(slice_1.updatePoliciesForVinRequestStatus('success'));
                if (!(policy.serialMotor !== '')) return [3 /*break*/, 5];
                dispatch(slice_1.updatePoliciesForMotorRequestStatus('requesting'));
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?motor=" + policy.serialMotor + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 4:
                motorResult = _a.sent();
                motorPolicy = dataOrUndefined(motorResult);
                dispatch(slice_1.updateCarPolicyForMotor(motorPolicy));
                dispatch(slice_1.updatePoliciesForMotorRequestStatus('success'));
                _a.label = 5;
            case 5:
                if (!(typeof policy !== 'undefined' &&
                    !carPolicies_1.isActive(policy) &&
                    policy.serialBody !== '')) return [3 /*break*/, 8];
                // fetch and validate linked VIN
                dispatch(slice_1.updatePoliciesForVinRequestStatus('requesting'));
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?vin=" + policy.serialBody + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 6:
                vinResult = _a.sent();
                vinPolicy = dataOrUndefined(vinResult);
                if (validPolicy(vinPolicy)) {
                    dispatch(slice_1.updateCarPolicyForVin(vinPolicy));
                    dispatch(slice_1.updatePoliciesForVinRequestStatus('success'));
                }
                else {
                    dispatch(slice_1.updatePoliciesForVinRequestStatus('failure'));
                    dispatch(slice_1.updatePoliciesForLicenseRequestStatus('success'));
                    return [2 /*return*/, dispatch(slice_1.updateReportPolicyData(true))];
                }
                // fetch and validate motor
                return [4 /*yield*/, localValidateMotor(dispatch, client, policy.serialMotor)];
            case 7:
                // fetch and validate motor
                _a.sent();
                _a.label = 8;
            case 8:
                dispatch(slice_1.updatePoliciesForLicenseRequestStatus('success'));
                return [2 /*return*/, dispatch(slice_1.updateReportPolicyData(true))];
            case 9:
                e_2 = _a.sent();
                return [2 /*return*/, dispatch(slice_1.updatePoliciesForLicenseRequestStatus('failure'))];
            case 10: return [2 /*return*/];
        }
    });
}); }; };
exports.requestExistingPoliciesForVin = function (vinNumber, client, isNewCar, disableHasActivePolicyValidation) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var dateAhead, dateAheadString, currentDateString, result, policy, motorResult, motorPolicy, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(slice_1.updatePoliciesForVinRequestStatus('requesting'));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                dateAhead = dateFormats_1.addDayToDate(new Date(), daysAheadSearchPolicy);
                dateAheadString = date_fns_1.format(dateAhead, dateFormat_1.dateFormatToServer);
                currentDateString = date_fns_1.format(new Date(), dateFormat_1.dateFormatToServer);
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?vin=" + vinNumber + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 2:
                result = _a.sent();
                policy = dataOrUndefined(result);
                dispatch(slice_1.updateMostRecentCarPolicy(policy));
                dispatch(slice_1.updateCarPolicyForVin(policy));
                if (!(typeof policy !== 'undefined' &&
                    ((!isNewCar && disableHasActivePolicyValidation) || !carPolicies_1.isActive(policy)) &&
                    policy.serialMotor !== '')) return [3 /*break*/, 4];
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?motor=" + policy.serialMotor + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 3:
                motorResult = _a.sent();
                motorPolicy = dataOrUndefined(motorResult);
                if ((!isNewCar && disableHasActivePolicyValidation) ||
                    !carPolicies_1.isActive(policy)) {
                    dispatch(slice_1.updateCarPolicyForMotor(motorPolicy));
                    dispatch(slice_1.updatePoliciesForVinRequestStatus('success'));
                    dispatch(slice_1.updatePoliciesForMotorRequestStatus('success'));
                    return [2 /*return*/, dispatch(slice_1.updateReportPolicyData(true))];
                }
                _a.label = 4;
            case 4: return [2 /*return*/, dispatch(slice_1.updatePoliciesForVinRequestStatus('success'))];
            case 5:
                e_3 = _a.sent();
                return [2 /*return*/, dispatch(slice_1.updatePoliciesForVinRequestStatus('failure'))];
            case 6: return [2 /*return*/];
        }
    });
}); }; };
exports.requestExistingPoliciesForMotor = function (motorNumber, client) { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var dateAhead, dateAheadString, currentDateString, result, policy, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch(slice_1.updatePoliciesForMotorRequestStatus('requesting'));
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dateAhead = dateFormats_1.addDayToDate(new Date(), daysAheadSearchPolicy);
                dateAheadString = date_fns_1.format(dateAhead, dateFormat_1.dateFormatToServer);
                currentDateString = date_fns_1.format(new Date(), dateFormat_1.dateFormatToServer);
                return [4 /*yield*/, network_1.processRequest({
                        method: 'GET',
                        url: "PolicyEmission/exists?motor=" + motorNumber + "&startDate=" + currentDateString + "&endDate=" + dateAheadString,
                        client: client,
                    })];
            case 2:
                result = _a.sent();
                policy = dataOrUndefined(result);
                dispatch(slice_1.updateMostRecentCarPolicy(policy));
                dispatch(slice_1.updateCarPolicyForMotor(policy));
                return [2 /*return*/, dispatch(slice_1.updatePoliciesForMotorRequestStatus('success'))];
            case 3:
                e_4 = _a.sent();
                return [2 /*return*/, dispatch(slice_1.updatePoliciesForMotorRequestStatus('failure'))];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
//# sourceMappingURL=carPoliciesActions.js.map